import type { EventLog } from "@/features/diagnostics/types";
import { formatShortDate } from "@/utils/formatters.ts";
import { EventLogIcon, EventLogItemRoot, EventLogMessage, EventLogTime } from "../lib/event-log-item.tsx";

type EventLogItemProps = { log: EventLog };

export default function EventLogItem({ log }: EventLogItemProps) {
    return (
        <EventLogItemRoot status={log.status}>
            <EventLogIcon status={log.status} />
            <EventLogTime>{formatShortDate(log.timestamp)}</EventLogTime>
            <EventLogMessage>{log.message}</EventLogMessage>
        </EventLogItemRoot>
    );
}
